(() => {
  const initDrawer = (toggle) => {
    if (!(toggle instanceof HTMLElement)) return;
    if (toggle.dataset.headerDrawerBound === "true") return;
    toggle.dataset.headerDrawerBound = "true";

    const drawerId = toggle.getAttribute("aria-controls");
    if (!drawerId) return;
    const drawer = document.getElementById(drawerId);
    if (!(drawer instanceof HTMLElement)) return;

    const ensureOverlay = () => {
      let overlay = document.querySelector(".header-v2__page-overlay");
      if (!overlay) {
        overlay = document.createElement("div");
        overlay.className = "header-v2__page-overlay";
      }
      if (overlay.parentElement !== document.body) {
        document.body.appendChild(overlay);
      }
      return overlay;
    };

    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    const closeButtons = drawer.querySelectorAll("[data-header-drawer-close]");
    const overlay = ensureOverlay();
    const firstLink = drawer.querySelector(".header-v2__drawer-link");
    let closeTimer;

    const closeSearch = () => {
      const header = document.querySelector("sht-header");
      const predictive = document.querySelector("sht-predictive-srch");
      if (predictive && typeof predictive.closeSearchResults === "function") {
        predictive.closeSearchResults(true);
      }
      if (predictive) {
        predictive.removeAttribute("open");
      }
      if (header) {
        header.classList.remove("header--predictive-search-open");
      }
      document.body.classList.remove("search-open");
      document.body.classList.remove("o-hidden");
    };

    const closeDrawer = () => {
      drawer.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      document.body.classList.remove("header-v2--drawer-open");
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        drawer.hidden = true;
      }, 220);
    };

    const openDrawer = () => {
      window.clearTimeout(closeTimer);
      if (document.body.classList.contains("search-open")) {
        closeSearch();
      }
      drawer.hidden = false;
      requestAnimationFrame(() => {
        drawer.classList.add("is-open");
      });
      document.body.classList.add("header-v2--drawer-open");
      toggle.setAttribute("aria-expanded", "true");
      if (firstLink instanceof HTMLElement) {
        firstLink.focus({ preventScroll: true });
      }
    };

    toggle.addEventListener("click", (event) => {
      event.preventDefault();
      if (drawer.classList.contains("is-open")) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    drawer.addEventListener("click", (event) => {
      if (event.target === drawer) {
        closeDrawer();
      }
    });

    closeButtons.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        event.preventDefault();
        closeDrawer();
      });
    });

    if (overlay) {
      overlay.addEventListener("click", closeDrawer);
    }

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeDrawer();
      }
    });
  };

  const boot = () => {
    document.querySelectorAll("[data-header-drawer-toggle]").forEach(initDrawer);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
